module.exports = __webpack_public_path__ + "img/ai2.146795ae.png";